import React from "react";

const DownloadButton = ({name, credentials}) => {
    return (<div className="flex items-center gap-2 cursor-pointer">
        <div>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.001 14.9425L12.001 3M12.001 3L7.06835 7.56318M12.001 3L16.9336 7.56318M4 18.9663V20.3827C4.40471 20.778 4.95361 21 5.52595 21H18.4741C19.0464 21 19.5953 20.778 20 20.3827V18.9663" stroke="#6446C3" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>

        </div>
        <div className="flex flex-col">
            <div className="text-lavender font-semibold">{name}</div>
            {credentials && <div className="text-lavender-60 text-xs">{credentials}</div>}
        </div>
    </div>)
}

export default DownloadButton